import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { store } from '../../redux/oldStore';
import { ServerResponse } from '../../utils/Server';
import { EasyImage } from '../Tools/EasyImage';
import { ISponsorInfo } from '../SlideShow/SlideShowTypes';
import { sanitizeHtml } from '../../utils/Tools';

interface ISponsorsPageResponse {
    customHtml?: string;
    sponsors: ISponsorInfo[];
}

const SponsorsPage = () => {
    const [data, setData] = useState<ISponsorsPageResponse>();

    useEffect(() => {
        store.server
            .postApi<ServerResponse<ISponsorsPageResponse>>('../Sponsors/Data', {})
            .then((x) => {
                if (x.Success) {
                    setData(x.Value);
                } else {
                    toast.error(x.Message, { autoClose: false });
                }
            });
    }, []);

    if (!data) return <></>;

    return (
        <div className="main-body-page grow" data-testid="sponsors-page">
            <div className="sponsors-page">
                {data.customHtml && (
                    <div className="editable" dangerouslySetInnerHTML={{ __html: sanitizeHtml(data.customHtml) }}></div>
                )}
                <div className="sponsorMain">
                    {data.sponsors.map((x, i) => (
                        <div key={i} className="sponsorItem">
                            {x.logoAddress ? (
                                <EasyImage src={x.logoAddress} alt={x.name} link={x.website} showCloudsOnError={true} />
                            ) : x.website ? (
                                <a href={x.website}>{x.name}</a>
                            ) : (
                                <span>{x.name}</span>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SponsorsPage;
